module.exports = __webpack_public_path__ + "static/media/cart-img.2dff71ce.jpg";